import React from "react"
import moment from "moment"

const ClaimTable = ({ data, setOpen, setLessonData }) => {

  return (
    <>
      <div className='table-responsive'>
        <table className="jean-table table">
          <tbody>
            {data?.map((lesson, i) => {
              return (
                <tr key={lesson?.id}>

                  <td>
                    <div className="therapist-info">
                      <h4 className="mb-1 fs-5">Day & Date</h4>
                      <p className="mb-0">
                        {lesson?.created_at ? moment(lesson?.created_at).format("dddd, DD MMM, YYYY")  : "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info ps-2">
                      <h4 className="mb-1 fs-5">Claim Amount</h4>
                      <p className="mb-0">
                        <i className="bi bi-currency-pound"></i> {lesson?.amount || "0"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info col-10">
                      <h4 className="mb-1 fs-5">Total Lessons</h4>
                      <p className="mb-0 text-truncate">
                        {lesson?.totallesson ? lesson?.totallesson : "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info col-10">
                      <h4 className="mb-1 fs-5">Status</h4>
                      {
                        lesson?.paymentproof ? (
                          <p className="mb-0 text-truncate text-center rounded-3 bg-green text-white">
                            Paid
                          </p>
                        ):(
                          <p className="mb-0 text-truncate text-center rounded-3 bg-black text-white">
                            Requested
                          </p>
                        )
                      }
                      
                    </div>
                  </td>

                  <td className="pe-4">
                    <div className='d-flex justify-content-end align-items-center'>
                      <div className="d-flex align-items-center">
                      <div className="action-buttons">
                          {
                            lesson.paymentproofUrl &&
                            <a
                              title="Download Receipt"
                              href={lesson.paymentproofUrl}
                              target="_blank"
                              className="ps-dropdown__toggle border-0 bg-black text-white  rounded-4 download me-3">
                              <i className="bi bi-download"></i>
                            </a>
                          }
                        </div>
                        <div className='me-3'>
                          <button
                            onClick={() => {
                              setOpen(true)
                              setLessonData(lesson)
                            }}
                            className="ps-dropdown__toggle border-0 bg-green text-white  py-2 px-3 rounded-4 ">
                            <i className="bi bi-eye"></i>
                          </button>

                        </div> 
                      </div>
                    </div>
                  </td>
                </tr>
              )
            })}

            {data?.length === 0 && (
              <div className="alert alert-success ps-4">No Claim Request Found !!</div>
            )}
          </tbody>
        </table>
      </div>

    </>
  )
}

export default ClaimTable
